export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: 'name',
        sortField: 'name',
        type: 'string',
        callback: 'domain',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'path',
        sortField: 'path',
        type: 'string',
        useInFilter: true,
        defaultSearch: false
    },
    {
        name: 'it1',
        visible: false,
        visibleRule: 'self.viewMode < 2',
        sortField: 'it1',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it3',
        visible: false,
        visibleRule: 'self.viewMode < 2',
        sortField: 'it3',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it5',
        visible: false,
        visibleRule: 'self.viewMode < 2',
        sortField: 'it5',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it10',
        visible: false,
        visibleRule: 'self.viewMode < 2',
        sortField: 'it10',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: '__slot:it50',
        sortField: 'it50',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'pagesinindex',
        visible: false,
        visibleRule: 'self.viewMode == 0',
        sortField: 'pagesinindex',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'vis',
        visible: false,
        visibleRule: 'self.viewMode == 0',
        sortField: 'vis',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: false,
    },
    {
        name: 'adscnt',
        visible: false,
        visibleRule: 'self.viewMode == 1',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adkeyscnt',
        visible: false,
        visibleRule: 'self.viewMode == 1',
        sortField: 'adkeyscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adtraf',
        visible: false,
        visibleRule: 'self.viewMode == 1',
        sortField: 'adtraf',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: false,
    },
    {
        name: 'adcost',
        visible: false,
        visibleRule: 'self.viewMode == 1',
        sortField: 'adcost',
        type: 'number',
        callback: 'currency',
        dataClass: 'ral',
        useInFilter: false,
        engine: "yandex",
    },
    {
        name: 'rsya',
        visible: false,
        visibleRule: 'self.viewMode == 2',
        sortField: 'rsya',
        type: 'number',
        callback: 'boolean',
        useInFilter: false,
    }
]
